"use strict";

/**
 * @namespace
 */
gc.gis.action = gc.gis.action || {};
/**
 * @namespace
 */
gc.gis.action.layer = gc.gis.action.layer || {};

/**
 * @classdesc
 * Basisklasse für ggf. komplexe Aktionen, die später ausgeführt werden sollen.
 *
 * @class
 * @extends gc.gis.GCObservable
 * @memberof gc.gis.action
 * @author Anton Popov <a.popov@brain-scc.de>
 */
gc.gis.action.GCAbstractAction = function()
{
	gc.gis.GCObservable.call( this );

	/**
	 * Kontext
	 *
	 * @type {*}
	 */
	this.target = this;
	/**
	 * Aufzurufende Funktion
	 *
	 * @type {function}
	 */
	this.func = null;
	/**
	 * Liste von Argumenten der aufzurufenden Funktion
	 *
	 * @type {Array}
	 */
	this.args = [];
};
gc.gis.action.GCAbstractAction.prototype = Object.create( gc.gis.GCObservable.prototype );

/**
 * Führt die Aktion aus.
 *
 * @public
 * @param {*} context optionaler Kontext, aus dem die Funktion aufgerufen wird.
 */
gc.gis.action.GCAbstractAction.prototype.execute = function(context )
{
	try
	{
		this.func.apply( context || this.target, this.args );
	}
	catch( err )
	{
		gc.gis.iface.log.error( this, err );
	}
};

